import Image from 'next/image'

import IconQuotes from '~/components/icons/IconQuotes'

export default function GrowersTestimonial({ src, name, content }) {
  return (
    <div className="text-grey-700 flex flex-col gap-y-8 md:flex-row md:gap-x-12 md:items-center">
      <div className="md:hidden">
        <Image
          src={src}
          alt="test"
          width={272}
          height={204}
          layout="responsive"
          objectFit="cover"
        />
      </div>
      <div className="hidden md:block md:order-1 md:w-1/2">
        <Image
          src={src}
          alt="test"
          width={387}
          height={516}
          layout="responsive"
          objectFit="contain"
        />
      </div>
      <div className="md:w-1/2">
        <IconQuotes />
        <p className="text-sm mt-8 leading-6 md:text-base">{content}</p>
        <p className="mt-6 text-sm font-medium md:text-base">{name}</p>
      </div>
    </div>
  )
}
